import Vue from 'vue'
import VueRouter from 'vue-router'
import commonJs from '../js/commonJs.js'


Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        redirect: {
            name: 'login'
        },
        component: resolve => require(['@/views/login/login.vue'], resolve)
    },
    {
        path: '/login',
        name: "login",
        meta: {
            LoginRequest: false,
            icon: '',
            title: '登录'
        },
        component: resolve => require(['@/views/login/login.vue'], resolve)
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            icon: '',
            title: '注册'
        },
        component: resolve => require(['@/views/register.vue'], resolve)
    },
    {
        path: '/forgetPass',
        name: 'forgetPass',
        meta: {
            icon: '',
            title: '开户忘记密码'
        },
        component: resolve => require(['@/views/login/forgetPass.vue'], resolve)
    },
    {
        path: '/forgetPassTwo',
        name: 'forgetPassTwo',
        meta: {
            icon: '',
            title: '未开户忘记密码'
        },
        component: resolve => require(['@/views/login/forgetPassTwo.vue'], resolve)
    },
    {
        path: '/indexno',
        name: 'indexno',
        meta: {
            icon: '',
            title: '未开户'
        },
        component: resolve => require(['@/views/indexno.vue'], resolve),
    },
    {
        path: '/openAccount',
        name: 'openAccount',
        meta: {
            title: '开户'
        },
        component: resolve => require(['@/views/openAccount/openAccount.vue'], resolve),
    },
    {
        path: '/openAcctAgreementUserSever',
        name: 'openAcctAgreementUserSever',
        meta: {
            title: '用户服务协议'
        },
        component: resolve => require(['@/components/agreement/openAcctAgreementUserSever.vue'], resolve),
    },
    {
        path: '/openAcctAgreement',
        name: 'openAcctAgreement',
        meta: {
            title: '投资人权益须知'
        },
        component: resolve => require(['@/components/agreement/openAcctAgreement.vue'], resolve),
    },
    {
        path: '/openAcctAgreementWt',
        name: 'openAcctAgreementWt',
        meta: {
            title: '委托支付协议'
        },
        component: resolve => require(['@/components/agreement/openAcctAgreementWt.vue'], resolve),
    },
    {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        meta: {
            title: '隐私政策'
        },
        component: resolve => require(['@/components/agreement/privacyPolicy.vue'], resolve),
    },

    {
        path: '/index',
        name: 'index',
        meta: {
            LoginRequest: false,
            icon: '',
            title: '首页'
        },
        children: [
            // 我的资产
            {
                name: 'myAssets',
                path: '/myAssets',
                children: [],
                component: resolve => require(['@/views/myAssets/myAssets.vue'], resolve)
            },
            // 恒宝宝资产信息
            {
                name: 'hbbAssetsMessage',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝资产信息'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/hbbAssetsMessage.vue'], resolve)

            },
            {
                name: 'combinationAssetsMessage',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '组合资产信息'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationAssetsMessage.vue'], resolve)

            },
            {
                name: 'publicAssetsMessage',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '公募资产信息'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicAssetsMessage.vue'], resolve)

            },
            // 私募
            {
                name: 'privateAssetsMessage',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '私募资产信息'
                },
                component: resolve => require(['@/views/myAssets/privateFunds/privateAssetsMessage.vue'], resolve)

            },
            {
                name: 'privateRecord',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '私募记录'
                },
                component: resolve => require(['@/views/myAssets/privateFunds/privateRecord.vue'], resolve)

            },
            {
                name: 'privateRecordDetail',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '私募记录详情'
                },
                component: resolve => require(['@/views/myAssets/privateFunds/privateRecordDetail.vue'], resolve)

            },
            {
                name: 'contract',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '私募合同'
                },
                component: resolve => require(['@/views/myAssets/privateFunds/contract.vue'], resolve)

            },

            // 恒宝宝模块
            {
                name: 'recharge',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝充值'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/recharge.vue'], resolve)

            },
            {
                name: 'remitMoneySuccess',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝汇款确认'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/remitMoneySuccess.vue'], resolve)

            },

            {
                name: 'takeCash',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝提现'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/takeCash.vue'], resolve)

            },
            {
                name: "record",
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝交易记录'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/record.vue'], resolve)

            },
            {
                name: "recordDetail",
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝交易记录详情'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/recordDetail.vue'], resolve)

            },

            {
                name: "fixedInvestment",
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝定投'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/fixedInvestment/fixedInvestment.vue'], resolve)

            },
            {
                name: "fixedInvestmentOpening",
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '恒宝宝定投开通'
                },
                component: resolve => require(['@/views/myAssets/hengBaobao/fixedInvestment/fixedInvestmentOpening.vue'], resolve)

            },
            // 公募基金
            {
                name: "publicPurchaseLists",
                path: '/myAssets',
                meta: {
                    title: '公募基金买入列表'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicPurchaseLists.vue'], resolve)

            },
            {
                name: "publicBuy",
                path: '/myAssets',
                meta: {
                    title: '公募基金购买'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicBuy.vue'], resolve)

            },
            {
                name: "publicRecord",
                path: '/myAssets',
                meta: {
                    title: '公募基金记录'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicRecord.vue'], resolve)

            },
            {
                name: "publicRecordDetail",
                path: '/myAssets',
                meta: {
                    title: '公募基金记录详情'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicRecordDetail.vue'], resolve)

            },
            {
                name: "publicFundTransform",
                path: '/myAssets',
                meta: {
                    title: '公募基金转换'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicFundTransform.vue'], resolve)

            },
            {
                name: "publicFundHoldSell",
                path: '/myAssets',
                meta: {
                    title: '公募基金卖出'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/publicFundHoldSell.vue'], resolve)

            },
            {
                name: "fundHoldDetails",
                path: '/myAssets',
                meta: {
                    title: '公募基金单个详情',

                },
                component: resolve => require(['@/views/myAssets/publicFunds/fundHoldDetails.vue'], resolve)

            },
            {
                name: "fundHoldBonusAgain",
                path: '/myAssets',
                meta: {
                    title: '公募基金红利再投'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/fundHoldBonusAgain.vue'], resolve)

            },
            {
                name: "fixedManagement",
                path: '/myAssets',
                meta: {
                    title: '公募基金定投管理'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/fixedManage/fixedManagement.vue'], resolve)

            },
            {
                name: "fixedBuyOpen",
                path: '/myAssets',
                meta: {
                    title: '公募基金买入开通'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/fixedManage/fixedBuyOpen.vue'], resolve)

            },
            {
                name: "fixedBuyConfirm",
                path: '/myAssets',
                meta: {
                    title: '公募基金买入开通确认'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/fixedManage/fixedBuyConfirm.vue'], resolve)

            },
            {
                name: "fixedStop",
                path: '/myAssets',
                meta: {
                    title: '公募基金终止'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/fixedManage/fixedStop.vue'], resolve)

            },
            {
                name: "fixedRevise",
                path: '/myAssets',
                meta: {
                    title: '公募基金修改'
                },
                component: resolve => require(['@/views/myAssets/publicFunds/fixedManage/fixedRevise.vue'], resolve)

            },
            // 基金组合
            {
                name: 'fundCombinationDetail',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '基金组合明细'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/fundCombinationDetail.vue'], resolve)
            },
            {
                name: 'combinationBuy',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    title: '基金组合买入'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationBuy.vue'], resolve)
            },
            {
                name: 'combinationSmartBuy',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    title: '智能组合买入'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationSmartBuy.vue'], resolve)
            },
            {
                name: 'combinationSell',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    title: '基金组合卖出'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationSell.vue'], resolve)
            },

            {
                name: 'combinationRecord',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    title: '基金组合记录'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationRecord.vue'], resolve)
            },
            {
                name: 'combinationRecordDetail',
                path: '/myAssets',
                meta: {
                    LoginRequest: false,
                    icon: '',
                    title: '基金组合记录详情'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationRecordDetail.vue'], resolve)
            },
            {
                name: 'combinationAdjustRecord',
                path: '/myAssets',
                meta: {
                    title: '基金组合调仓记录'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/adjustPosition/combinationAdjustRecord.vue'], resolve)
            },
            {
                name: 'combinationAdjustRecordDetail',
                path: '/myAssets',
                meta: {
                    title: '基金组合调仓记录详情'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/adjustPosition/combinationAdjustRecordDetail.vue'], resolve)
            },
            {
                name: 'combinationAdjustDetail',
                path: '/myAssets',
                meta: {
                    title: '基金组合调仓记录详情'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/adjustPosition/combinationAdjustDetail.vue'], resolve)
            },
            {
                name: 'combinationSmartAdjust',
                path: '/myAssets',
                meta: {
                    title: '精准理财组合调仓'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/adjustPosition/combinationSmartAdjust.vue'], resolve)
            },
            {
                name: 'severAgreement',
                path: '/myAssets',
                meta: {
                    title: '基金组合服务协议'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/severAgreement.vue'], resolve)
            },
            {
                name: 'fundCombinationSingleBuy',
                path: '/myAssets',
                meta: {
                    title: '基金组合再次购买'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/fundCombinationSingleBuy.vue'], resolve)
            },
            {
                name: 'combinationIncomedetails',
                path: '/myAssets',
                meta: {
                    title: '组合收益明细'
                },
                component: resolve => require(['@/views/myAssets/fundCombination/combinationIncomedetails.vue'], resolve)
            },



            // 我的诊断
            {
                name: 'myDiagnosis',
                path: '/myDiagnosis',
                component: resolve => require(['@/views/myDiagnosis/myDiagnosis.vue'], resolve)
            },
            {
                name: 'fundDiagnosisPay',
                path: '/fundDiagnosisPay',
                component: resolve => require(['@/views/myDiagnosis/fundDiagnosisPay.vue'], resolve)
            },
            {
                name: 'fundDiagnosticServiceAgreement',
                path: '/myDiagnosis',
                component: resolve => require(['@/views/myDiagnosis/fundDiagnosticServiceAgreement.vue'], resolve)
            },
            // 我的自选
            {
                name: 'myChoice',
                path: '/myChoice',
                component: resolve => require(['@/views/myChoice/myChoice.vue'], resolve)
            },
            // 卡券
            {
                name: 'coupon',
                path: '/coupon',
                component: resolve => require(['@/views/coupon/coupon.vue'], resolve),
            },
            {
                name: 'couponDetail',
                path: '/coupon',
                component: resolve => require(['@/views/coupon/couponDetail.vue'], resolve),
            },

            {
                name: 'member',
                path: '/member',
                meta: {
                    title: '点财通会员'
                },
                component: resolve => require(['@/views/member/member.vue'], resolve)
            },
            {
                name: 'pointsExchange',
                path: '/member',
                meta: {
                    title: '积分兑换1'
                },
                component: resolve => require(['@/views/member/pointsExchange.vue'], resolve)
            },
            {
                name: 'memberBuy',
                path: '/member',
                meta: {
                    title: '点财通购买'
                },
                component: resolve => require(['@/views/member/memberBuy.vue'], resolve)
            },
            {
                name: 'memberPay',
                path: '/member',
                meta: {
                    title: '点财通支付页面'
                },
                component: resolve => require(['@/views/member/memberPay.vue'], resolve)
            },
            {
                name: 'memberPayResult',
                path: '/memberPayResult',
                meta: {
                    title: '点财通支付结果页面'
                },
                component: resolve => require(['@/views/member/memberPayResult.vue'], resolve)
            },
            {
                name: 'memberSeverAgreement',
                path: '/member',
                meta: {
                    title: '点财通服务协议'
                },
                component: resolve => require(['@/views/member/memberSeverAgreement.vue'], resolve)
            },

            {
                name: 'couponExchange',
                path: '/member',
                meta: {
                    title: '积分兑换2'
                },
                component: resolve => require(['@/views/member/couponExchange.vue'], resolve),
            },
            {
                name: 'pointsRecord',
                path: '/member',
                meta: {
                    title: '积分记录'
                },
                component: resolve => require(['@/views/member/pointsRecord.vue'], resolve),
            },
            // 账户管理
            {
                name: 'accountManagement',
                path: '/accountManagement',
                component: resolve => require(['@/views/accountManagement/accountManagement.vue'], resolve)
            },
            {
                name: 'cardReplaceRecord',
                path: '/accountManagement',
                component: resolve => require(['@/views/accountManagement/bankCardManage/cardReplaceRecord.vue'], resolve)
            },
            {
                name: 'bankCardAdd',
                path: '/accountManagement',
                component: resolve => require(['@/views/accountManagement/bankCardManage/bankCardAdd.vue'], resolve)
            },
            // 消息中心
            {
                name: 'messageCenter',
                path: '/messageCenter',
                meta: {
                    title: '消息中心'
                },
                component: resolve => require(['@/views/messageCenter/messageCenter.vue'], resolve),
            },
            {
                name: 'messageCon',
                path: '/messageCenter',
                meta: {
                    title: '公告内容'
                },
                component: resolve => require(['@/views/messageCenter/messageCon.vue'], resolve)
            },
            {
                name: 'perfectInformation',
                path: '/accountManagement',
                meta: {
                    title: '信息完善'
                },
                component: resolve => require(['@/views/accountManagement/personalData/perfectInformation.vue'], resolve)
            },
            {
                name: 'riskResult',
                path: '/accountManagement',
                meta: {
                    title: '风险测评结果'
                },
                component: resolve => require(['@/views/accountManagement/riskAssessment/riskResult.vue'], resolve)
            },
            {
                name: 'riskAssessmentDescription',
                path: '/accountManagement',
                meta: {
                    title: '风险测评结果'
                },
                component: resolve => require(['@/views/accountManagement/riskAssessment/riskAssessmentDescription.vue'], resolve)
            },

            // 银行卡验证
            {
                name: 'bankCardVerification',
                path: '/myAssets',
                component: resolve => require(['@/components/lv-common/bankCardVerification.vue'], resolve)
            },
            // 汇付银行卡验证
            {
                name: 'bankCardVerificationHf',
                path: '/myAssets',
                component: resolve => require(['@/components/lv-common/bankCardVerificationHf.vue'], resolve)
            },
            // 我的顾问
            {
                name: 'myAdviser',
                path: '/myAdviser',
                component: resolve => require(['@/views/myAdviser/myAdviser.vue'], resolve)
            },
            {
                name: 'myfinancialAdvisor',
                path: '/myAdviser',
                meta: {
                    title: '我的理财顾问'
                },
                component: resolve => require(['@/views/myAdviser/myfinancialAdvisor.vue'], resolve)
            },
            {
                name: 'followLists',
                path: '/myAdviser',
                meta: {
                    title: '我关注的理财顾问'
                },
                component: resolve => require(['@/views/myAdviser/followLists.vue'], resolve)
            },
            // 意见反馈
            {
                name: 'feedback',
                path: '/feedback',
                component: resolve => require(['@/views/feedback/feedback.vue'], resolve)
            },
            // 清算调账
            {
                path: '/liquidation',
                name: 'liquidation',
                meta: {
                    title: '清算调账'
                },
                component: resolve => require(['@/views/liquidation/liquidation.vue'], resolve)
            },
            // 通用模板示例
            {
                name: 'commonTemplate',
                path: '/commonTemplate',
                component: resolve => require(['@/views/commonTemplate.vue'], resolve)
            },


        ],
        component: resolve => require(['@/views/index.vue'], resolve)
    },
    {
        path: '/agreementElectronicSever',
        name: 'agreementElectronicSever',
        meta: {
            title: '私募协议'
        },
        component: resolve => require(['@/components/agreement/agreementElectronicSever.vue'], resolve)
    },
    {
        path: '/openAcctAgreementRisk',
        name: 'openAcctAgreementRisk',
        meta: {
            title: '风险提示'
        },
        component: resolve => require(['@/components/agreement/openAcctAgreementRisk.vue'], resolve)
    },
    {
        path: '/riskDisclosure',
        name: 'riskDisclosure',
        meta: {
            title: '风险揭示书'
        },
        component: resolve => require(['@/components/agreement/riskDisclosure.vue'], resolve)
    },
    {
        path: '/customerMaintenanceFee',
        name: 'customerMaintenanceFee',
        meta: {
            title: '客户维护费'
        },
        component: resolve => require(['@/components/agreement/customerMaintenanceFee.vue'], resolve)
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            title: '未登录状态'
        },
        component: resolve => require(['@/components/lv-common/logout.vue'], resolve)
    },











]



const router = new VueRouter({
    routes,
    // mode: 'history',
    // base: '/personal/'
})


// // 登录拦截功能
router.beforeEach((to, from, next) => {
    // console.log(to, from);
    if (to.query.fundcode) { // 外部跳转链接
        window.sessionStorage.setItem('querycode', to.query.fundcode)
        window.sessionStorage.setItem('business', to.query.business)
        window.sessionStorage.setItem('riskStr', to.query.riskStr)
        window.sessionStorage.setItem('leval', to.query.leval)
        window.sessionStorage.setItem('question', to.query.question) // 组合诊断参数
        to.query.amount ? window.sessionStorage.setItem('amount', to.query.amount) : window.sessionStorage.setItem('amount', '')
        next({
            name: commonJs.getSession(window.sessionStorage.getItem('business')),
            params: {
                fundcode: to.query.fundcode,
                amount: to.query.amount,
                riskStr: to.query.riskStr,
                leval: to.query.leval
            },

        })
        commonJs.setCookie('acticePath', to.path, 3)
    }
    if (to.path === '/login' || to.path === '/register' || to.path === '/indexno' || to.path === '/forgetPass' || to.path === '/forgetPassTwo' ||
        to.path === '/openAccount' || to.path === '/openAcctAgreementUserSever' || to.path === '/openAcctAgreement' || to.path === '/openAcctAgreementWt' ||
        to.path === '/privacyPolicy' || to.path === '/riskDisclosure' || to.path === '/customerMaintenanceFee') return next()
    const tokenStr = commonJs.getCookie('sessionid')
    if (!tokenStr) return next('/login')
    next()
})


// 解决 Vue 重复点击相同路由
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default router